import React, { useState } from 'react';
import { Edit2 } from 'lucide-react';

type InsightSectionProps = {
  insight: string;
  onUpdateInsight: (insight: string) => void;
};

const InsightSection: React.FC<InsightSectionProps> = ({ insight, onUpdateInsight }) => {
  const [showInsightInput, setShowInsightInput] = useState(false);
  const [editingInsight, setEditingInsight] = useState(insight);

  const handleEditInsight = () => {
    setEditingInsight(insight);
    setShowInsightInput(true);
  };

  const handleInsightSubmit = () => {
    const trimmedInsight = editingInsight.trim();
    onUpdateInsight(trimmedInsight);
    setShowInsightInput(false);
  };

  return (
    <div className="w-full mt-4">
      {!showInsightInput && (
        <div className="flex justify-between items-center mb-2">
          <p className="text-sm text-gray-600 italic flex-grow">
            {insight.trim() ? `Insight: ${insight}` : 'Add your insight...'}
          </p>
          <button
            onClick={handleEditInsight}
            className="ml-2 p-2 rounded-full bg-gray-200 text-blue-500 hover:bg-blue-500 hover:text-white transition-colors duration-200"
            title="Edit Insight"
          >
            <Edit2 size={20} />
          </button>
        </div>
      )}
      {showInsightInput && (
        <div className="w-full">
          <textarea
            className="w-full p-2 border rounded"
            rows={4}
            placeholder="Write your insight..."
            value={editingInsight}
            onChange={(e) => setEditingInsight(e.target.value)}
          ></textarea>
          <div className="flex justify-end mt-2">
            <button
              onClick={handleInsightSubmit}
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors duration-200"
            >
              Save Insight
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default InsightSection;